import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=a51c052a&scoped=true&"
import script from "./AccountData.vue?vue&type=script&lang=js&"
export * from "./AccountData.vue?vue&type=script&lang=js&"
import style0 from "./AccountData.vue?vue&type=style&index=0&id=a51c052a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c052a",
  null
  
)

export default component.exports